export { DataTable } from "@/components/common/DataTable";
export type { DataTableColumn, DataTableAction, DataTableProps } from "@/components/common/DataTable";
